import React from 'react';
import { Link } from 'react-router-dom';
import {ADDRESS, BUSINESS_HOURS, EMAIL, PHONE} from "@/constants";

const Footer: React.FC = () => {
  const products = [
    { name: '轮式机器人', href: '/products' },
    { name: '通用机器人', href: '/products' },
    { name: '微型执行器', href: '/products' },
    { name: '轴向磁通电机', href: '/products' },
    { name: 'IMU姿态传感器', href: '/products' },
    { name: '轻量化材料（镁合金材料）', href: '/products' },
  ];
  const solutions = [
    { name: '工业智造', href: '/solutions/1' },
    { name: '智慧物流', href: '/solutions/2' },
    { name: '智慧康养', href: '/solutions/3' },
    { name: '智慧导览', href: '/solutions/4' },
    { name: '科教赋能', href: '/solutions/5' },
    { name: '智慧社区', href: '/solutions/6' },
  ];
  return (
    <footer className="bg-primary-900 text-white">
      <div className="container-max medium-section-padding">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          <div className="space-y-4">
            <div className="flex items-center space-x-3">
              <div className="w-200 h-10 bg-transparent flex items-center justify-center">
                <img src={require("../static/img/logo-white.png")} alt="灵犀机器人" className="w-full h-8 object-cover" />
              </div>
            </div>
            <p className="text-primary-300 leading-relaxed">
              专注于智能机器人研发与制造，为客户提供全方位的机器人解决方案，引领智能制造新时代。
            </p>
            <div className="flex space-x-4">
              <Link
                to="/contact"
                className="w-10 h-10 bg-primary-800 rounded-lg flex items-center justify-center hover:bg-tech-blue transition-colors">
                <i className="fab fa-weixin"></i>
              </Link>
              {/*<a href="#" className="w-10 h-10 bg-primary-800 rounded-lg flex items-center justify-center hover:bg-tech-blue transition-colors">*/}
              {/*  <i className="fab fa-weibo"></i>*/}
              {/*</a>*/}
              {/*<a href="#" className="w-10 h-10 bg-primary-800 rounded-lg flex items-center justify-center hover:bg-tech-blue transition-colors">*/}
              {/*  <i className="fab fa-linkedin"></i>*/}
              {/*</a>*/}
            </div>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-4">产品中心</h3>
            <ul className="space-y-2">
              {products.map((product) => (
                <li key={product.name}>
                  <Link
                    to={product.href}
                    className="text-primary-300 hover:text-white transition-colors"
                  >
                    {product.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-4">行业应用</h3>
            <ul className="space-y-2">
              {solutions.map((solution) => (
                <li key={solution.name}>
                  <Link
                    to={solution.href}
                    className="text-primary-300 hover:text-white transition-colors"
                  >
                    {solution.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-4">联系我们</h3>
            <div className="space-y-3">
              <div className="flex items-center space-x-3">
                <i className="fas fa-map-marker-alt text-tech-blue"></i>
                <span className="text-primary-300">{ADDRESS}</span>
              </div>
              <div className="flex items-center space-x-3">
                <i className="fas fa-phone text-tech-blue"></i>
                <span className="text-primary-300">{PHONE}</span>
              </div>
              <div className="flex items-center space-x-3">
                <i className="fas fa-envelope text-tech-blue"></i>
                <span className="text-primary-300">{EMAIL}</span>
              </div>
              <div className="flex items-center space-x-3">
                <i className="fas fa-clock text-tech-blue"></i>
                <span className="text-primary-300">{BUSINESS_HOURS}</span>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-primary-800 mt-4 pt-4">
          <div className="flex items-center justify-center gap-4">
            <p className="text-primary-400 text-sm">
            Copyright © 2025 安徽灵犀机器人有限公司 版权所有
            </p>
            <p className="text-primary-400 text-sm">
              <a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener">皖ICP备2025083340号</a>
              <span className="px-2">|</span>
              <a href="https://www.beian.gov.cn/" target="_blank" rel="noopener">皖公网安备340号</a>
            </p>
            {/*<div className="flex space-x-6 text-sm">*/}
            {/*  <Link*/}
            {/*    to="/sources"*/}
            {/*    className="text-primary-400 hover:text-white transition-colors"*/}
            {/*  >*/}
            {/*    隐私政策*/}
            {/*  </Link>*/}
            {/*  <Link*/}
            {/*    to="/sources"*/}
            {/*    className="text-primary-400 hover:text-white transition-colors"*/}
            {/*  >*/}
            {/*    服务条款*/}
            {/*  </Link>*/}
            {/*</div>*/}
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;